/// <amd-module name="Feed/Core/LegacyActions/LegacyFeedActions" />
import { Action } from "VSS/Reflux/Action";

/**
 * Updates feed selection in the legacy store
 */
export let UpdateLegacyFeedSelection = new Action<string>();
